import { render, staticRenderFns } from "./UserMarket.vue?vue&type=template&id=518a662e&"
import script from "./UserMarket.vue?vue&type=script&lang=js&"
export * from "./UserMarket.vue?vue&type=script&lang=js&"
import style0 from "./UserMarket.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports